import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Bell } from "lucide-react";
import { api } from "@/lib/api";

export function AdminGlobalSearch() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [notif, setNotif] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const t = useRef(null);
  useEffect(() => { api.get("/admin/notifications").then((r) => setNotif(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    clearTimeout(t.current);
    if (q.trim().length < 2) { setRes([]); return undefined; }
    t.current = setTimeout(() => api.get("/admin/search", { params: { q } }).then((r) => setRes(r.data.results)).catch(() => {}), 300);
    return () => clearTimeout(t.current);
  }, [q]);
  const readAll = () => api.post("/admin/notifications/read-all").then(() => setNotif({ ...notif, unread: 0 }));
  return (
    <div className="flex items-center gap-3 flex-1 justify-end">
      <div className="relative w-full max-w-sm">
        <Search size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher client, n°, plaque, date…" className="w-full pl-8 pr-3 py-2 bg-black/60 border border-[#DCB457]/25 text-xs focus:border-[#DCB457] outline-none" data-testid="admin-global-search" />
        {res.length > 0 && (
          <div className="absolute right-0 left-0 top-full mt-1 bg-[#0a0a0a] border border-[#DCB457]/30 max-h-96 overflow-y-auto z-50" data-testid="admin-global-results">
            {res.map((r, i) => (
              <Link key={i} to={r.link} onClick={() => { setQ(""); setRes([]); }} className="block px-3 py-2 border-b border-white/5 hover:bg-[#DCB457]/10 normal-case tracking-normal">
                <span className="text-[9px] uppercase tracking-[0.18em] text-[#DCB457]">{r.type}</span>
                <span className="block text-sm text-white">{r.label}</span><span className="block text-[11px] text-white/45">{r.sub}</span>
              </Link>))}
          </div>)}
      </div>
      <div className="relative">
        <button onClick={() => setOpen(!open)} className="relative text-white/60 hover:text-[#DCB457]" data-testid="admin-notif-bell" aria-label="Notifications">
          <Bell size={16} />{notif.unread > 0 && <span className="absolute -top-1.5 -right-2 bg-[#DCB457] text-black text-[9px] font-bold px-1 rounded-full" data-testid="admin-notif-badge">{notif.unread}</span>}
        </button>
        {open && (
          <div className="absolute right-0 top-full mt-2 w-80 bg-[#0a0a0a] border border-[#DCB457]/30 z-50 max-h-96 overflow-y-auto normal-case tracking-normal" data-testid="admin-notif-panel">
            <button onClick={readAll} className="w-full text-right px-3 py-2 text-[10px] uppercase text-[#DCB457] border-b border-white/5">Tout marquer comme lu</button>
            {!notif.items.length ? <p className="p-3 text-xs text-white/45">Aucune notification.</p> : notif.items.map((n) => (
              <Link key={n.id} to={n.link || "#"} onClick={() => setOpen(false)} className={`block px-3 py-2 border-b border-white/5 text-xs ${n.is_read ? "text-white/50" : "text-white"}`}>{n.title}<span className="block text-white/40">{n.body}</span></Link>))}
          </div>)}
      </div>
    </div>
  );
}
